<template>
  <div class="section-layout" :class="{ 'is-radius-top': isRadiusTop }">
    <div
      class="section-icon"
      :style="{ backgroundImage: icon ? `url(${icon})` : '' }"
    ></div>
    <div class="section-body">
      <div class="section-header">
        <div class="section-title">{{ title }}</div>
      </div>
      <div v-if="tips" class="section-tips">{{ tips }}</div>
      <div class="section-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSectionLayout',
  props: {
    title: {
      type: String,
      default: '',
    },
    tips: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    isRadiusTop: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.section-layout {
  box-sizing: border-box;
  margin-top: 8px;
  padding: 16px 12px;
  background: #fff;
  display: flex;
  align-items: flex-start;

  &.is-radius-top {
    border-radius: 12px 12px 0 0;
  }

  .section-icon {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin-right: 6px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
  }

  .section-body {
    flex: 1;
    overflow: hidden;
  }

  .section-header {
    display: flex;
    align-items: center;
    min-height: 18px;
  }

  .section-title {
    flex: 1;
    min-width: 0;
    color: #333;
    font-size: 15px;
    font-weight: 500;
    line-height: 18px;
  }

  .section-tips {
    margin-top: 8px;
    color: #ff4b4d;
    font-size: 11px;
    line-height: 15px;
  }

  .section-content {
    margin-top: 16px;
  }
}
</style>
